import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem, Autocomplete, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { CustomSnackbar } from "../../../components/common/CustomSnackbar/CustomSnackbar";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { useProductAttributeStore } from "../../../hooks/useProductAttributeStore";
import { useSpecificAttributeStore } from "../../../hooks/useSpecificAttributeStore";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'rut', label: 'RUT', align: 'center' },
    { type: 'text', field: 'name', label: 'Nombre', align: 'center' },
    { type: 'text', field: 'charge', label: 'Cargo', align: 'center' },
    { type: 'text', field: 'phone', label: 'Teléfono', align: 'center' },
    { type: 'text', field: 'email', label: 'Correo', align: 'center' },
];

const states = [
    { name: 'Activo', value: '1' },
    { name: 'Desactivo', value: '0' },
]

type ValuesContact = {
    n: number
    rut: string
    name: string,
    charge: string,
    phone: string,
    email: string,
    // status: string,
}

export const SectionContacts: React.FC<any> = (props): JSX.Element | any => {

    const { action, dataContacts, setDataContacts, currentSection, handlePrevSection, handleNextSection, sections, clearState, productSelected, closeModal, listproducts, onSubmit, loadingsave, contacts, setContacts } = props;

    const { getproductAttributeByCompany } = useProductAttributeStore();

    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [loadingtable, setLoadingtable] = useState<boolean>(false);
    const [attributeselected, setattributeselected] = useState<any>('');
    const [specificselected, setspecificselected] = useState<any>('');
    // const [contacts, setContacts] = useState<any>([]);

    const [data, setData] = useState<ValuesContact>({
        n: 0,
        rut: '',
        name: '',
        charge: '',
        phone: '',
        email: '',
        // status: '1',
    });

    const validateForm = (values) => {
        let errors: any = {};
        // if(!values.rut) errors.rut = "el campo es requerido";
        // if(!values.name) errors.name = "el campo es requerido";
        // if(!values.position) errors.position = "el campo es requerido";
        // if(!values.email) errors.email = "el campo es requerido";
        // if(!values.phone) errors.phone = "el campo es requerido";
        return errors;
    }

    const onDelete = (rowSelected: any) => {
        const attributes = contacts.filter(attribute => attribute.n !== rowSelected.n)
        setContacts([...attributes])
    }

    const addContacts = (values, resetForm) => {
        setContacts([...contacts, { ...values, n: contacts.length + 1, id: null }])
        resetForm()
    }

    const onCancel = () => {
        handlePrevSection && handlePrevSection();
    }

    const saveProducts = async () => {
        onSubmit && onSubmit(dataContacts)
    }

    return (
        <Grid sx={{ height: '100%', position: 'relative' }}>
            <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={addContacts}>
                {({ values, errors, touched, handleSubmit, handleChange, setFieldValue, resetForm }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Grid container sx={{ maxHeight: '65vh', overflowY: 'scroll', paddingRight: '5px' }}>
                                <Grid item container xs={12} spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>RUT:</FormLabel>
                                        <TextField
                                            id="rut"
                                            type="text"
                                            name="rut"
                                            fullWidth
                                            size="small"
                                            value={values.rut}
                                            onChange={handleChange}
                                            error={errors.rut && touched.rut ? true : false}
                                            inputProps={{
                                                maxLength: 10,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Nombre:</FormLabel>
                                        <TextField
                                            id="name"
                                            type="text"
                                            name="name"
                                            fullWidth
                                            size="small"
                                            value={values.name}
                                            onChange={handleChange}
                                            error={errors.name && touched.name ? true : false}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Cargo:</FormLabel>
                                        <TextField
                                            id="charge"
                                            type="text"
                                            name="charge"
                                            fullWidth
                                            size="small"
                                            value={values.charge}
                                            onChange={handleChange}
                                            error={errors.charge && touched.charge ? true : false}
                                            placeholder="Gerente general, Pago a proveedores, contador..."
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Teléfono:</FormLabel>
                                        <TextField
                                            id="phone"
                                            type="text"
                                            name="phone"
                                            fullWidth
                                            size="small"
                                            value={values.phone}
                                            onChange={handleChange}
                                            error={errors.phone && touched.phone ? true : false}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Correo:</FormLabel>
                                        <TextField
                                            id="email"
                                            type="email"
                                            name="email"
                                            fullWidth
                                            size="small"
                                            value={values.email}
                                            onChange={handleChange}
                                            error={errors.email && touched.email ? true : false}
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} md={6}>
                                        <FormLabel>Estado:</FormLabel>
                                        <Select
                                            id="status"
                                            value={values.status}
                                            size="small"
                                            onChange={(event) => { 
                                                setFieldValue("status", event.target.value);
                                            }}
                                            error={ errors.status && touched.status ? true : false }
                                            fullWidth
                                        >
                                            {
                                                states.map((state, i) => {
                                                    return <MenuItem key={i} value={state.value}>{state.name}</MenuItem>;
                                                })
                                            }
                                        </Select>
                                    </Grid> */}

                                    <Grid item xs={12}>
                                        <Grid item xs={12} display='flex' justifyContent='space-between' alignContent='center' alignItems='center'>
                                            <FormLabel>Lista de contactos</FormLabel>
                                            <Button onClick={() => addContacts(values, resetForm)} size="small" variant="contained" className='btn-secondary'>
                                                {'Añadir'}
                                            </Button>
                                        </Grid>
                                        <CustomTable
                                            disabled_title
                                            columns={columns}
                                            loading={loadingtable}
                                            rows={contacts || []}
                                            onRowClick={() => { }}
                                            hasOptions
                                            onDelete={onDelete}
                                            RowsPerPage={3}
                                            dense
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                                <ModalFooter
                                    confirmText={'Guardar registro'}
                                    onConfirm={saveProducts}
                                    cancelText={"Atrás"}
                                    onCancel={onCancel}
                                    loading={loadingsave}
                                />
                            </div>
                        </form>
                    )
                }}
            </Formik>
        </Grid>
    )
}